import { getAddressComponent, getCity, getState, getZipCode } from 'shared/google_maps'

const DEFAULT_OPTIONS: google.maps.places.AutocompleteOptions = {
  componentRestrictions: { country: ['us'] }
}

export interface SetupAutocompleteOptions {
  options: google.maps.places.AutocompleteOptions
  callback: (place: google.maps.places.PlaceResult) => void
}

export type AutoCompleteCallbackPayload = Record<string, string>

export type AutoCompleteCallback = (result: AutoCompleteCallbackPayload) => void

export const autocompletes: [google.maps.places.Autocomplete, HTMLInputElement][] = []

export async function setupAutocomplete(input: HTMLInputElement, opts: SetupAutocompleteOptions) {
  const options = opts.options
  const callback = opts.callback

  if(!input) {
    return
  }

  const { Autocomplete } = await google.maps.importLibrary("places") as google.maps.PlacesLibrary;

  input.addEventListener('focus', () => { input.autocomplete = 'off' }) // TODO: this used to be "none". Make sure that "off" works too.

  const autocomplete = new Autocomplete(input, options);
  input.dataset['origPlaceholder'] = input.placeholder

  autocompletes.push([autocomplete, input])

  autocomplete.addListener('place_changed', function() {
    const place = autocomplete.getPlace();
    if(place && place.address_components) {
      callback(place)
    }
  })

  return autocomplete
}

export async function bindStreetAddressAutocomplete(streetAddressInput: HTMLInputElement, callback: AutoCompleteCallback, options: google.maps.places.AutocompleteOptions = DEFAULT_OPTIONS ): Promise<google.maps.places.Autocomplete|undefined> {
  return await setupAutocomplete(streetAddressInput, {
    options: {
      ...options,
      types: ['geocode'],
      fields: ['address_component'],
    },
    callback: (place) => {
      callback({
        'StreetAddress': `${getAddressComponent(place.address_components, ['street_number'])} ${getAddressComponent(place.address_components, ['route'], 'short_name')}`.trim(),
        'City':          getCity(place.address_components),
        'State':         getState(place.address_components),
        'ZIP_Code':      getZipCode(place.address_components),
      })
    }
  })
}

export function unbindStreetAddressAutocomplete(autocomplete: google.maps.places.Autocomplete) {
  autocomplete.unbindAll()
}

if(typeof window !== 'undefined') {
  window.gm_authFailure = function() {
    autocompletes.forEach(([autocomplete, input]) => {
      autocomplete.unbindAll()
      window.google?.maps?.event?.clearInstanceListeners?.(input)
      input.disabled = false
      input.placeholder = input.dataset['origPlaceholder'] ?? ''
      input.classList.remove('pac-target-input')
      input.classList.remove('gm-err-autocomplete')
      input.style.backgroundImage = ''
    })
  }
}
